import { Autocomplete, TextField } from "@mui/material";
import React, { useContext, useEffect } from "react";
import DataContext from "../../Context/DataContext";

function SelectInput({
  rowId,
  id,
  name,
  title,
  value,
  defaultValue,
  options,
  required,
  handleFunction,
  error,
  helper_text,
  multiple,
  sectionTitle,
  disabled,
}) {

  const {handleMultipleSelectInputs,educationCode} = useContext(DataContext);
 
  return (
    <div style={{ textAlign: "start" }}>
      <span style={{ padding: "0 4px", color: "#6e6e6e" }}>
      <label>{title}{required && <span style={{color:'red'}}>*</span>}</label>
      </span>
      <Autocomplete
        id={id}
        key={id}
        fullWidth
        name={name}
        disabled={disabled}
        value={value}
        defaultValue={defaultValue}
        onChange={(e, values) => multiple ?  handleMultipleSelectInputs(e, values, rowId, id, sectionTitle,name) : handleFunction(e,values,name)}
        options={options}
        getOptionLabel={(item) => {
          return item?.title ? item?.title : "";
        }}
        required={required}
        sx={{ margin: "4px 0" }}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            // label={title}
            fullWidth
            placeholder={`Select ${title}`}
            required={required}
            error={error}
            
            helperText={helper_text}
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />
        )}
      />
    </div>
  );
}

export default SelectInput;
